const ToUpBtn = () => {
  const toUpBtn = document.querySelector(".to-up-btn");

  if (toUpBtn) {
     window.onscroll = () => {
      if (window.scrollY > window.innerHeight) {
        toUpBtn.classList.add("active");
      } else {
        toUpBtn.classList.remove("active");
      }
    };

    toUpBtn.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
}

export default ToUpBtn;

